import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert, AlertProps } from 'shared/mui/Alert/Alert';
import { Button } from 'shared/mui/Buttons';

type Props = {
  onClick: VoidFunction;
  message?: string;
} & AlertProps;

export const EmptyListAlert: React.FC<Props> = ({ onClick, message }) => {
  const translate = useTypedTranslate();
  const content = message ?? translate('app.filter.emptyList');

  return (
    <Alert
      action={
        <Button
          color="inherit"
          label={translate('app.buttons.filter')}
          onClick={onClick}
          size="small"
          variant="text"
        />
      }
      severity="info"
    >
      {content}
    </Alert>
  );
};
